import type { UniclientAction } from '@lemonade-hq/uniclient-chat';
import { Flex, Icon, spacing, Text } from '@lemonade-hq/uniclient-theme';
import { useCallback } from 'react';
import * as styles from './WizardContextMenu.css';

export interface WizardContextMenuProps {
  readonly items: UniclientAction[];
  readonly performAction?: (action?: UniclientAction) => Promise<unknown>;
}

export const WizardContextMenu: React.FC<WizardContextMenuProps> = ({ items, performAction }) => {
  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>, item: UniclientAction): void => {
      if (event.key === 'Enter') {
        void performAction?.(item);
      }
    },
    [performAction],
  );

  return (
    <Flex flexDirection="column">
      {items.map((item, index) => (
        <Flex
          alignItems="center"
          className={styles.item}
          data-wizard-menu-item={`wizard-menu-item-${index + 1}`}
          gap={spacing.s12}
          key={item.content}
          onClick={() => void performAction?.(item)}
          onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => handleKeyDown(event, item)}
          p={spacing.s16}
          tabIndex={0}
        >
          {item.icon && <Icon name={item.icon} size="md" />}

          <Text key={item.content}>{item.content}</Text>
        </Flex>
      ))}
    </Flex>
  );
};
